import { TemporaryWorkPlacementEnum } from 'src/store/placementDetailsPageSlice/types';

// =============================== Constants =============================== //

export const TWPRadioOptions = {
  MATCH_ROLE_NO_MODIFICATIONS: {
    value: TemporaryWorkPlacementEnum.MATCH_ROLE_NO_MODIFICATIONS,
    ariaLabel: 'match-role-no-modifications',
    label: {
      header: 'Placement Available. No Modifications required.',
      body: 'Restrictions match with an available process path. No modifications are required to accommodate your restrictions.',
    },
  },
  MATCH_ROLE_WITH_MODIFICATIONS: {
    value: TemporaryWorkPlacementEnum.MATCH_ROLE_WITH_MODIFICATIONS,
    ariaLabel: 'match-role-with-modifications',
    label: {
      header: 'Placement Available. Modifications or TLD required.',
      body:
        'Restrictions match with either a process path or temporary light duty assignment. Modifications may be ' +
        'applied to your role.',
    },
  },
  NO_MATCH: {
    value: TemporaryWorkPlacementEnum.NO_MATCH,
    ariaLabel: 'no-match',
    label: {
      header: 'No Placement Available.',
      body: 'There are no temporary work placements available that match with your restrictions.',
    },
  },
} as const;
